;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputYesNo', inputYesNo)

  /* @ngInject */
  function inputYesNo () {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        options: '<',
        readOnly: '<',
        value: '<',
        disabled: '<',
        auditStatus: '<',
        nonConformity: '<'
      },
      templateUrl: '/core/directives/input-yes-no/input-yes-no-directive.html?$$REVISION$$',
      controller: 'InputYesNoController'
    }
  }
})()
